import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { getAppRoutes } from './consts';
import NotFoundPage from '../not-found';
import { useRedirectContent } from './hooks';
import useUserContext from '../../hooks/useUserContext';
import CommandPalette from '../../components/organisms/CommandPalette';
import routes from '../../setup/consts/routes';
import { MARKETPLACE_TEST_BOOT } from '../../components/layouts/MainLayout/consts';

const AppRoutesSwitch: React.FC = () => {
  const redirectContent = useRedirectContent();
  const { user } = useUserContext();

  const appRoutes = getAppRoutes({
    isAdvancedUser: Boolean(user?.isAdvancedUser),
    isSandoogUser: Boolean(user?.isSandoogUser),
  });

  if (redirectContent) {
    return redirectContent;
  }

  return (
    <Switch>
      {MARKETPLACE_TEST_BOOT && (
        <Redirect exact from="/" to={routes.MARKETPLACE} />
      )}
      {/* /settings is a section prefix, not a page — redirect bare
          visits to the first sub-page so the sidebar settings dropdown,
          deep links, and the command palette all resolve cleanly
          instead of falling through to NotFound. */}
      <Route exact path={routes.SETTINGS_SECTION}>
        <Redirect to={routes.ACCOUNT_DETAILS} />
      </Route>
      {appRoutes.map(({ path, component: Component, layout: Layout }) => (
        <Route {...{ path }} exact key={path}>
          {Layout ? (
            <Layout>
              <Component />
            </Layout>
          ) : (
            <Component />
          )}
        </Route>
      ))}
      <Route>
        <NotFoundPage />
      </Route>
    </Switch>
  );
};
const AppRoutes: React.FC = () => (
  <Router>
    <AppRoutesSwitch />
    <CommandPalette />
  </Router>
);
export default AppRoutes;
